<template>
  <div>
    <section v-for="item,i in materials" :key="i">
      <div class="print-header">
        <h1 class="title">{{ materialData.creator.department.split("/")[0] }}材料出库单</h1>
        <div class="info">
          <div class="info-item">出库单号：{{materialData.number}}</div>
          <div class="info-item">出库时间：{{materialData.time}}</div>
          <div class="info-item">仓库：{{materialData.house.name}}</div>
          <div class="info-item half" v-if="materialData.projectName">相关工程：{{materialData.projectName}}</div>
          <div class="info-item half" v-if="materialData.customer">客户：{{materialData.customer}}</div>
          <!-- <div class="info-item">领用人：{{materialData.user.name}}</div> -->
          <!-- <div class="info-item">出库类型：{{materialData.type}}</div>
          <div class="info-item" v-if="materialData.purpose">事由：{{materialData.purpose}}</div> -->
        </div>
      </div>

      <div class="data-table">
        <el-table :data="item" :summary-method="getSummaries" show-summary border>
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column prop="number" label="材料编号" width="100">
          </el-table-column>
          <el-table-column prop="name" label="明细名称" width="">
          </el-table-column>
          <el-table-column prop="dlName" label="材料类别" width="200">
          </el-table-column>
          <el-table-column prop="unitName" align="center" width="90" label="计量单位">
          </el-table-column>
          <el-table-column prop="" align="center" width="100" label="数量">
            <template slot-scope="scope">
              {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="" align="center" width="100" label="单价(元)">
            <template slot-scope="scope">
              {{ scope.row.price && parseFloat(scope.row.price).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="totalPrice" align="center" width="100" label="总价(元)">
          </el-table-column>
        </el-table>
        <div v-if="i===(materials.length-1)">
          <!-- <div class="table-total">
          <span>总数量：{{ materialData.slTotal }} 件</span>
          <span>总金额：{{ materialData.zjTotal }} 元</span>
        </div> -->
        </div>
      </div>
      <div class="footer">
        <span class="footer-item r">第{{i+1}}页 / 共{{materials.length}}页</span>
        <!-- <span class="footer-item">出库管理员：{{materialData.creator.name}}</span> -->
        <span class="footer-item" style="padding-right:90px;">白色-财务&nbsp;&nbsp;&nbsp;&nbsp;红色-仓库&nbsp;&nbsp;&nbsp;&nbsp;黄色-存根</span>
        <span class="footer-item">领料人：<span class="footer-input"></span></span>
        <span class="footer-item">部门负责人：<span class="footer-input"></span></span>
        <span class="footer-item">仓管员：<span class="footer-input"></span></span>
      </div>
      <div style="page-break-after: always;"></div>
    </section>
  </div>
</template>
<script>
  export default {
    props: ['materials', 'materialData'],
    methods: {
      getTime(time) {
        return util.getFormatDate(time, true)
      },
      // 合计
      getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 1 || index === 5) {
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toFixed(2)
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      // 
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/print/materialUseOut.vue